import axios from 'axios';

export default {
  list(purchaseOrderId){
      // console.log("LIST purchase Reeive : ",purchaseOrderId);
      let params = {purchaseOrderId:purchaseOrderId};
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-receives", {params:params})
        .then(response=>{
          return response.data;
        })
  },
  generatePurchaseReceiveNumber(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-receives/number")
      .then(response=>{
        return response.data.purchase_receive_number;
      })
  },
  receivePurchaseOrder(purchaseOrderReceive){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-receives", purchaseOrderReceive)
      .then(response=>{
        return response.data
      })
  },
  getPurchaseReceiveStatus(purchaseOrderId){
    let params = {};
    params.purchaseOrderId=purchaseOrderId;
    params.status = "";
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-receives", {params})
      .then(response=>{
        return response.data
      })
  }

}
